import {createFileRoute} from '@tanstack/react-router';

import {LearningProgressPage} from '@/modules/learning/pages/LearningProgressPage';

export const Route = createFileRoute('/_authenticated/learning/$moduleId_/progress')({
  component: LearningProgressPage,
});
